<!--table 编辑 -->
<template>
  <div class="custom_table_template2">
    <el-card style="margin-top: 10px">
      <div slot="header" style="font-weight: bold">病历</div>
      <el-row>
        <el-form label-width="80px">
          <el-form-item label="病人主诉:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="diagnosisOtherParam.presentingComplaint"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="简要病史:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="diagnosisOtherParam.pastHistory"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="体检情况:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="diagnosisOtherParam.inspection"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="过敏史:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="diagnosisOtherParam.allergyHistory"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </el-row>
    </el-card>

    <el-card>
      <div slot="header" style="font-weight: bold">诊断信息</div>
      <el-table :data="diagnosis" style="width: 100%">
        <el-table-column label="诊断名称">
          <template slot-scope="scope1">
            <el-autocomplete
              class="inline-input"
              v-model="diagnosis[scope1.$index].diagnosisName"
              :fetch-suggestions="querySearch"
              placeholder="请输入诊断名称"
              @select="
                (event) => {
                  handleSelect(event, scope1.$index);
                }
              "
              @input="changeInput(scope1.$index)"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column label="诊断备注">
          <template slot-scope="scope1">
            <el-input
              type="textarea"
              :rows="2"
              class="inline-input"
              v-model="diagnosis[scope1.$index].diagnosisRemark"
              placeholder="请输入诊断名称"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" header-align="right">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-between">
              <el-link
                icon="el-icon-plus"
                size="mini"
                type="primary"
                @click="handleAdd(scope.$index, scope.row)"
                :underline="false"
                style="font-size: 14px; margin-left: 40px"
              ></el-link>
              <el-link
                icon="el-icon-delete"
                size="mini"
                @click="handleDelete(scope.$index, scope.row)"
                type="danger"
                :underline="false"
              ></el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card style="text-align: center">
      <el-button type="primary" @click="add">保存</el-button>
      <el-button type="danger" @click="cancel">取消</el-button>
    </el-card>
  </div>
</template>
<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      textarea: "",
      form: {},
      diagnosis: [{ list: {} }],
      value: "",
      restaurants: [],
      qKey: "",
      diagnosisOtherParam: {},
      list: [],
    };
  },
  props: {
    ddid: {
      type: String,
    },
  },
  mounted() {
    this.loadAllRemote();
    this.loadlistData();
  },
  methods: {
    //保存病历和诊断
    add() {
      let _this = this;

      let diagnosisList = [];
      let obj;
      for (let i in _this.diagnosis) {
        if(!this.diagnosis[i].diagnosisRemark){
          Message({
              showClose: true,
              message: "备注不能为空",
              type: "error",
            });
            return
        }
        if (_this.diagnosis[i].list) {
          obj = {};
          obj.diagnosisId = "";
          obj.diagnosisCode = _this.diagnosis[i].list.diagnosisCode;
          obj.diagnosisName = _this.diagnosis[i].list.diagnosisName;
          obj.diagnosisRemark = _this.diagnosis[i].diagnosisRemark;
          diagnosisList.push(obj);
        } else {
          obj = {};
          obj.diagnosisId = _this.diagnosis[i].diagnosisId;
          obj.diagnosisCode = _this.diagnosis[i].diagnosisCode;
          obj.diagnosisName = _this.diagnosis[i].diagnosisName;
          obj.diagnosisRemark = _this.diagnosis[i].diagnosisRemark;
          diagnosisList.push(obj);
        }
      }
      axiosUtil(
        {
          service: "smarthos.yygh.generate.medical.records",
          orderId: _this.ddid,
          hosId: "01001",
          presentingComplaint: _this.diagnosisOtherParam.presentingComplaint,
          pastHistory: _this.diagnosisOtherParam.pastHistory,
          inspection: _this.diagnosisOtherParam.inspection,
          allergyHistory: _this.diagnosisOtherParam.allergyHistory,
          diagnosisList: JSON.stringify(diagnosisList),
        },
        ({ code }) => {
          if (code == "0") {
            Message({
              showClose: true,
              message: "保存成功",
              type: "success",
            });
            _this.loadlistData();
          }
        }
      );
    },
    cancel() {
      this.diagnosisOtherParam = {};
      this.diagnosis = [{ list: {} }];
      this.loadlistData();
    },
    //加载病历和诊断列表
    loadlistData() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.yygh.select.medical.records.diagnosis",
          orderId: _this.ddid,
          hosId: "01001",
        },
        ({ code, diagnosisOtherParam, list, msg }) => {
          if (code == "0") {
            _this.diagnosisOtherParam = diagnosisOtherParam;
            if (JSON.stringify(list) != "[]") {
              _this.diagnosis = list;
            }
          }
        }
      );
    },
    //改变input触发
    changeInput(idx) {
      this.qKey = this.diagnosis[idx].diagnosisName;
        this.loadAllRemote();
    },
    querySearch(queryString, cb) {
      cb(this.restaurants);
    },
    //加载诊断列表
    loadAllRemote() {
      let _this = this;
      axiosUtil(
          {
            service: "smarthos.yygh.select.diagnostic.dictionary.info.list.new",
            hosId: "01001",
            diagname: _this.qKey,
            pagesize:500,
            pagenum:1
          },
          ({ code, diagnosisList, msg }) => {
            if (code == "0") {
              if (JSON.stringify(diagnosisList) != "[]") {
                diagnosisList.map((item) => {
                  item.value = item.diagnosisName;
                  return item;
                });
                _this.restaurants = diagnosisList;
              } else {
                _this.restaurants = [];
                Message({
                  showClose: true,
                  message: "暂无查询到此诊断",
                  type: "error",
                });
              }
            }
          }
        );
    },
    //选择诊断
    handleSelect(item, idx) {
      this.diagnosis[idx].list = item;
      this.qKey = "";
      // this.loadAllRemote();
    },
    //删除诊断
    deleteDiagnosis(index) {
      let _this = this;
      if (this.diagnosis[index].diagnosisId) {
        axiosUtil(
          {
            service: "smarthos.yygh.delete.medical.records.diagnosis",
            orderId: _this.ddid,
            diagnosisId: _this.diagnosis[index].diagnosisId,
          },
          ({ code, msg }) => {
            if (code == "0") {
              //  _this.diagnosis.splice(index, 1);
              Message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
              _this.loadlistData();
            }
          }
        );
      } else {
        this.diagnosis.splice(index, 1);
      }
    },
    //添加诊断
    handleAdd(index, row) {
      this.diagnosis.push({ list: {} });
    },
    //删除诊断
    handleDelete(index, row) {
      if (this.diagnosis.length > 1) {
        this.deleteDiagnosis(index);
      } else {
        Message({
          showClose: true,
          message: "第一项不能删除",
          type: "error",
        });
      }
    },
  },
};
</script>
<style lang="scss">
.custom_table_template2 {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
